import React from 'react'
import type { TUnderlyingDataExportDto } from '@homepal/api-contract'

import { IUnderlyingDataResponse } from 'types/GlobalWidget'
import { TMetricView } from 'types/GlobalMetric'
import { TDataDialogColumn } from '../types'

import { useAccountSettings } from 'redux/hooks/SignedInAccount'

import { Sort } from 'utils/types'
import { ParsedData } from 'utils/underlyingData'

import Box from 'components_new/atoms/Box'

import ToggleButton from 'components_new/molecules/ToggleButton'

import ColumnsButton from './ColumnsButton'
import ExportButton from './ExportButton'

export interface ToolbarProps {
  columns: { [columnId: string]: TDataDialogColumn }
  entityId: string | null
  fetched: boolean
  // only the first rows were fetched; more match the selection
  hasMore: boolean
  metricView?: TMetricView & { title: string }
  onChangeView: (value: 'chart' | 'table') => void
  onEditColumns: (value: TDataDialogColumn[]) => void
  // exports every row on the server, for a table that holds only the first
  onExportAll: (fileName: string) => Promise<TUnderlyingDataExportDto>
  onExported: () => void
  parsedData: ParsedData & { sort: Sort }
  rawData: IUnderlyingDataResponse | null
  view: 'chart' | 'table'
}

const Toolbar = (props: ToolbarProps) => {
  const {
    columns,
    entityId,
    fetched,
    hasMore,
    metricView,
    onChangeView,
    onEditColumns,
    onExportAll,
    onExported,
    parsedData,
    rawData,
    view
  } = props

  const { isCompanyGroup } = useAccountSettings()
  const isApiAccess = location.pathname.includes('api-access')

  return (
    <>
      <Box sx={{ flex: 1, height: 30 }}>
        {isApiAccess ? null : (
          <ToggleButton
            disableBorder={true}
            fullWidth={false}
            items={[
              { iconName: 'Table', title: 'Tabell', value: 'table' },
              { iconName: 'BarChart', title: 'Diagram', value: 'chart' }
            ]}
            onChange={(_, value) => onChangeView(value)}
            size="small"
            sx={{ height: '100%' }}
            value={view}
          />
        )}
      </Box>

      {isCompanyGroup || isApiAccess ? null : (
        <ColumnsButton
          columns={columns}
          entityId={entityId}
          onSubmit={onEditColumns}
          rawData={rawData}
        />
      )}

      {metricView ? (
        <ExportButton
          fetched={fetched}
          fileTitle={metricView.title}
          hasMore={hasMore}
          onExportAll={hasMore && !isApiAccess ? onExportAll : undefined}
          onExported={onExported}
          parsedData={parsedData}
        />
      ) : null}
    </>
  )
}

export default Toolbar
